import axios from 'axios'
import store from './store'
import eventBus from './utils/eventBus'

const http = axios.create({
  baseURL: process.env.VUE_APP_BACKEND,
  headers: {
    'Content-Type': 'application/json',
  },
})

let isAlreadyFetchingAccessToken = false
let tokenFetchError = false
let subscribers = []

function onAccessTokenFetched(accessToken) {
  subscribers = subscribers.filter((callback) => callback(accessToken))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

http.interceptors.request.use((config) => {
  config.headers['x-referer'] = location.href.split('?')[0] // Add referer
  if (
    store.state.auth.accessToken !== null &&
    !config.url.includes('oauth/token') &&
    !config.url.includes('user/password-reset') &&
    !config.url.includes('user/password-reset/confirm') &&
    !config.url.includes('user/password-setup/confirm')
  ) {
    config.headers.Authorization = `Bearer ${store.state.auth.accessToken}` // eslint-disable-line no-param-reassign
  }
  return config
})

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const { config, response } = error
    if ((error.response && error.response.status === 400) || error.response.status === 409) {
      if (error.response.data.error !== 'invalid_grant') {
        eventBus.$emit('error400', error.response.data)
      }
    } else if (error.response && error.response.status !== 401 && error.response.status !== 404) {
      eventBus.$emit('error500', error.response.data)
    }
    if (
      response &&
      response.status === 401 &&
      !config.url.includes('oauth/token') &&
      !config.url.includes('user/password-reset') &&
      !config.url.includes('user/password-reset/confirm') &&
      !config.url.includes('user/password-setup/confirm')
    ) {
      if (!isAlreadyFetchingAccessToken && !tokenFetchError) {
        isAlreadyFetchingAccessToken = true
        store
          .dispatch('auth/authPromise')
          .then((authResponse) => {
            tokenFetchError = false
            isAlreadyFetchingAccessToken = false
            onAccessTokenFetched(authResponse.data.access_token)
          })
          .catch(() => {
            tokenFetchError = true
            isAlreadyFetchingAccessToken = false
            onAccessTokenFetched(null)
            store.dispatch('auth/logout')
          })
      }
      if (tokenFetchError) {
        return Promise.reject(error)
      }
      return new Promise((resolve) => {
        addSubscriber((accessToken) => {
          if (accessToken === null) {
            return Promise.reject(error)
          }
          config.headers.Authorization = `Bearer ${accessToken}` // eslint-disable-line no-param-reassign
          return resolve(http(config))
        })
      })
    }
    if (!error.response && !axios.isCancel(error)) {
      eventBus.$emit('errorNetwork', {
        message: 'Selhalo připojení k serveru. Opakujte akci později',
      })
    }
    return Promise.reject(error)
  }
)

export default http
